/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/21/2019
 *
 */

import axios from 'axios';

/** Backend API origin for local dev when env-cmd / .env is not loaded (Spring Boot default). */
export const API_BASE_URL =
    (process.env.REACT_APP_BASE_URL && process.env.REACT_APP_BASE_URL.trim()) ||
    'http://localhost:5000';

const fetchClient = () => {
    const defaultOptions = {
        baseURL: API_BASE_URL
    };

    return axios.create(defaultOptions);
};

export default fetchClient();
